import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';

/** Tooltip shell: wrapper + popup panel. */
@Component({
  selector: 'kt-custom-tooltip-shell',
  templateUrl: './custom-tooltip-shell.component.html',
  styleUrls: ['./custom-tooltip-shell.component.scss']
})
export class CustomTooltipShellComponent implements OnDestroy {
  /** Panel width (px) */
  @Input() panelWidth = 194;
  /** Hide panel when false */
  @Input() showPanel = true;

  @ViewChild('tooltipWrapper') tooltipWrapper!: ElementRef<HTMLElement>;
  @ViewChild('tooltipPanel') tooltipPanel!: ElementRef<HTMLElement>;

  panelTop = 0;
  panelLeft = 0;
  isVisible = false;

  private panelAppendedToBody = false;

  constructor(private readonly cdr: ChangeDetectorRef) { }

  onWrapperEnter(): void {
    if (!this.showPanel) {
      this.isVisible = false;
      return;
    }

    this.appendPanelToBody();
    this.recalculatePosition();
    this.isVisible = true;
    window.addEventListener('scroll', this.onScroll, true);
  }

  onWrapperLeave(): void {
    this.isVisible = false;
    window.removeEventListener('scroll', this.onScroll, true);
  }

  private onScroll = (): void => {
    this.isVisible = false;
    this.cdr.detectChanges();
    window.removeEventListener('scroll', this.onScroll, true);
  };

  private recalculatePosition(): void {
    const wrapperRect = this.tooltipWrapper?.nativeElement?.getBoundingClientRect();
    const panelRect = this.tooltipPanel?.nativeElement?.getBoundingClientRect();

    if (!wrapperRect || !panelRect) {
      this.panelTop = 0;
      this.panelLeft = 0;
      return;
    }

    const viewportMargin = 12;
    const maxRight = window.innerWidth - viewportMargin;
    const panelWidth = panelRect.width || this.panelWidth;
    const projectedRight = wrapperRect.left + panelWidth;
    const shouldAlignLeft = projectedRight > maxRight;

    let left = shouldAlignLeft
      ? wrapperRect.right - panelWidth
      : wrapperRect.left;

    left = Math.max(viewportMargin, Math.min(left, maxRight - panelWidth));

    this.panelLeft = left;
    this.panelTop = wrapperRect.bottom + 6;
  }

  private appendPanelToBody(): void {
    const panelEl = this.tooltipPanel?.nativeElement;
    if (!panelEl || this.panelAppendedToBody) return;

    document.body.appendChild(panelEl);
    this.panelAppendedToBody = true;
  }

  ngOnDestroy(): void {
    const panelEl = this.tooltipPanel?.nativeElement;
    if (panelEl && this.panelAppendedToBody && panelEl.parentNode === document.body) {
      document.body.removeChild(panelEl);
    }
    window.removeEventListener('scroll', this.onScroll, true);
  }
}
